<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>             

          <b-form>
            <b-form-group
              label="Cuenta Debitar"
              label-for="bancoCuentaDebitoNombre"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="bancoCuentaDebitoNombre" 
                v-model= "bancoCuentaDebitoNombre" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <app-banco-cuenta-credito
              label="Cuenta Acreditar"
              :nombre="bancoCuentaCreditoNombre"
              :lista="bancosCuentasList"
              :labelCols="labelCols"
              :valido="bancoCuentaCreditoValida"
              :msjInvalido="bancoCuentaCreditoInvalidaMsj"
              @updated="bancoCuentaCreditoActualizada">
            </app-banco-cuenta-credito>

            <b-form-group
              label="Fecha Cred/Deb"
              label-for="fechaCreditoDebito"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaCreditoDebito" 
                v-model="fechaCreditoDebito" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Importe Debitar"
              label-for="importe"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model" 
                :state="importeValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Cotización"
              label-for="cotizacion"
              :labelCols="labelCols"
              description="Cotización del dolar al momento de la compra/venta"
              horizontal>
              <b-form-input 
                id="cotizacion"
                v-model.trim="$v.cotizacion.$model" 
                :state="cotizacionValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cotizacionFeedback">
                {{ cotizacionInvalidaMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Importe Acreditar"
              label-for="importeAcreditar"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importeAcreditar"
                :value="importeAcreditar" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="close">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import BancoCuentaCredito from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { required, decimal, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancoMovimientoDivisas/getField',
  mutationType: 'bancoMovimientoDivisas/updateField',
});

export default {
  name: 'CompraVentaDivisas',
  components: {
    appBancoCuentaCredito: BancoCuentaCredito,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  props: {
    cuenta: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      noValidar: true,
      bancoCuentaCreditoValida: null,
      bancoCuentaCreditoInvalidaMsj: '',
      importeValido: null,
      importeInvalidoMsj: '',
      cotizacionValida: null,
      cotizacionInvalidaMsj: '',

      bancosCuentas: [],
      bancosCuentasList: [],

      labelCols: 3,
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',
    }
  },
  computed: {
    ...mapFields([
      'id',
      'bancoCuentaDebitoNombre',
      'monedaDebitoId',
      'bancoCuentaCredito',
      'bancoCuentaCreditoNombre',
      'monedaCreditoId',
      'fechaCreditoDebito',
      'importe',
      'cotizacion'
    ]),
    importeAcreditar() {
      let importeAcreditar = 0;

      if (this.importe && this.cotizacion && this.bancoCuentaCredito) {
        if (this.monedaDebitoId == 101) {
          importeAcreditar = this.importe / this.cotizacion;
        } else if (this.monedaDebitoId == 102) {
          importeAcreditar = this.importe * this.cotizacion;
        }
      }
      return importeAcreditar.toFixed(2);
    }
  },  
  created() {
    this.showSpinner();
    this.$store.dispatch('bancoMovimientoDivisas/inicializar')
      .then(() => {
        this.getDatosAdicionales();
        return;
      })
      .then(() => {
          if (this.cuenta != null) {
          this.$store.dispatch('bancoMovimientoDivisas/setBancoCuentaDebito', this.cuenta);    
        }   
      })
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      /* Solo se permiten transferencias entre cuentas de distinta misma moneda */
      let params = {
        monedaId: this.cuenta ? (this.cuenta.monedaId == 101? 102 : 101) : 0,
      }
      this.$store.dispatch('bancoscuentas/getList', params)
        .then(() => {
            this.bancosCuentas = this.$store.getters['bancoscuentas/list']
            this.bancosCuentasList = this.$store.getters['bancoscuentas/selectList']
          })
          .catch(() => this.showAlert('Se produjo un error al recuperar la información de cuentas bancarias.', 'danger'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.decimal || !this.$v.importe.minValue) {
            this.importeInvalidoMsj = 'El importe del movimiento debe ser un valor numérico positivo';
          }
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }

      if (campo == 'cotizacion' || validarTodos) {
        if (this.$v.cotizacion.$error) {
          this.cotizacionValida = false;
          if (!this.$v.cotizacion.decimal || !this.$v.cotizacion.minValue) {
            this.cotizacionInvalidaMsj = 'La cotización del movimiento debe ser un valor numérico positivo';
          }
        } else {
          this.cotizacionValida = null;
          this.cotizacionInvalidaMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      let bancoCuentaDebitoId = 0;
      if (this.cuenta) {
        if (this.cuenta.id) {
          bancoCuentaDebitoId = this.cuenta.id;
        }
      }      

      let bancoCuentaCreditoError = true;
      if (this.bancoCuentaCredito) {
        if (this.bancoCuentaCredito.id) {
          if (this.bancoCuentaCredito.id != 0) {
            bancoCuentaCreditoError = Boolean(false);
          }
        }
      }
      if (bancoCuentaCreditoError) {
        save = false;
        this.bancoCuentaCreditoValida = false;
        this.bancoCuentaCreditoInvalidaMsj = 'Debe seleccionar la cuenta de destino correspondiente.';
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('bancoMovimientoDivisas/save')
            .then(() => this.$emit('close', true))
            .catch( error => this.showAlert(error, 'danger'))
            .finally(() => this.hideSpinner())
        }
      } 
    },
    close() {
      this.$emit('close', false);
    },
    bancoCuentaCreditoActualizada(bancoCuentaNombre) {
      this.bancoCuentaCreditoNombre = bancoCuentaNombre;

      let bancoCuentaCredito = null;
      if (this.bancoCuentaCreditoNombre) {
        bancoCuentaCredito = this.getSelected(this.bancosCuentas, this.bancoCuentaCreditoNombre);
      }
      this.$store.dispatch('bancoMovimientoDivisas/setBancoCuentaCredito', bancoCuentaCredito);
      this.bancoCuentaCreditoValida = null;
      this.bancoCuentaCreditoInvalidaMsj = '';
    },
  },
  watch: {
  },
  validations: {
    importe: {
      decimal,
      minValue: minValue(0.01),      
    },
    cotizacion: {
      decimal,
      minValue: minValue(0.01),      
    }
  },  
}
</script>

<style>
</style>
